import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './../styles/header.css';
import './../styles/global.css';

export default function Header() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      // Forzar navegación a login aunque haya error
      navigate('/login', { replace: true });
    }
  };

  return (
    <header className="header d-flex justify-content-between align-items-center">
      <div>
        <img src="./agrosuper.png" alt="" className='img-icon' />
        <span className="header-title">SISTEMA DE REPORTES VERIFICACION EPP</span>
      </div>
      <div className="d-flex align-items-center gap-2">
        {user && (
          <span className="user-name">{user.name || user.email}</span>
        )}
        <div className="logout-container" onClick={handleLogout}>
          {/* <span className="logout-text">Cerrar Sesión</span> */}
          <div className="logout-icon">
            <span className="arrow"></span>
          </div>
        </div>
      </div>
    </header>
  );
}